import type { JSX } from 'react';
import { ElementEvenement } from './ElementEvenement.js';
import type { BarreSemaine } from './periodes.js';
import styles from './Calendrier.module.css';

/**
 * La barre d'un événement de journées entières sur une ligne de sept
 * colonnes : posée dans la grille de la semaine, à sa colonne et à sa voie.
 * Les bords coupés par la semaine sont droits et annoncés `data-suite`.
 */
export function BarreEvenement({
  barre,
  premiereLigne,
  decalageColonne = 0,
}: {
  barre: BarreSemaine;
  /** Numéro de la ligne de la grille où commence la voie 0. */
  premiereLigne: number;
  /** Colonnes de gouttière avant les sept jours (la semaine, avec ses heures). */
  decalageColonne?: number;
}): JSX.Element {
  const { evenement } = barre;
  return (
    <div
      className={styles.barreEvenement}
      style={{
        gridColumn: `${barre.colonneDebut + 1 + decalageColonne} / ${barre.colonneFin + 2 + decalageColonne}`,
        gridRow: barre.voie + premiereLigne,
      }}
      data-teinte={evenement.teinte}
      data-evidence={evenement.evidence ? 'oui' : undefined}
      data-debut-coupe={barre.debutCoupe ? 'oui' : undefined}
      data-fin-coupee={barre.finCoupee ? 'oui' : undefined}
      data-ui="calendrier-barre-evenement"
    >
      <ElementEvenement
        evenement={evenement}
        className={styles.lienBarre}
        titre={evenement.detail ? `${evenement.titre} — ${evenement.detail}` : evenement.titre}
      >
        {evenement.titre}
      </ElementEvenement>
    </div>
  );
}
